module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "uploader-files"
  }, [_vm._t("default", [_c('ul', _vm._l((_vm.files), function(file) {
    return _c('li', {
      key: file.id
    }, [_c('uploader-file', {
      attrs: {
        "file": file
      }
    })], 1)
  }))], {
    files: _vm.files
  })], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-221b87a8","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/files.vue
// module id = 72
// module chunks = 0